import { render } from "./indexConfigClickSignComponent.vue?vue&type=template&id=2c6d2bd5"
import script from "./indexConfigClickSignComponent.vue?vue&type=script&lang=js"
export * from "./indexConfigClickSignComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__